/// <amd-module name="VSSUI/ResponsiveLayout" />
export { ResponsiveLayout } from "./Components/ResponsiveLayout/ResponsiveLayout";
export { IResponsiveLayoutProps, ResponsiveOrientation } from "./Components/ResponsiveLayout/ResponsiveLayout.Props";
